import { lazy } from "react";
import ProtectedAuth from "./PrivateAuth";
import NotFound from "./NotFound";
import PlansGuard from "./PlansGuard";
const OrderStatusPos = lazy(() => import("../Views/Main/POS/OrderStatus"));
const Dashboard = lazy(() => import("../Views/Main/Dashboard/Dashboard"));
const Staff = lazy(() => import("../Views/Main/Staff/Staff"));
const MakeOrder = lazy(() => import("../Views/Main/MakeOrder/MakeOrder"));
const ItemLayout = lazy(() => import("../Views/Main/Item&Category/Index"));
const AddItemPage = lazy(() => import("../Views/Main/Item&Category/AddItem"));
const UpdateItemPage = lazy(() => import("../Views/Main/Item&Category/UpdateItem"));
const Order = lazy(() => import("../Views/Main/Orders/Order"));
const Setting = lazy(() => import("../Views/Main/Settings/Setting"));
const Customer = lazy(() => import("../Views/Customer/Customer"));
const Sales = lazy(() => import("../Views/Main/Sales/Sales"));
const Plans = lazy(() => import("../Views/Main/Plans"));

export const PrivateAuth = () => {
  return [
    {
      element: <ProtectedAuth />,
      children: [
        {
          path: "/dashboard",
          name: "resturant",
          element: <Dashboard />,
        },
        {
          path: "/staff",
          name: "resturant",
          element: <Staff />,
        },
        {
          path: "/makeorder",
          name: "resturant",
          element: <MakeOrder />,
        },
        {
          path: "/menus",
          name: "resturant",
          element: <ItemLayout />,
        },
        {
          path: "/addItem",
          name: "resturant",
          element: <AddItemPage />,
        },
        {
          path: "/updateItem",
          name: "resturant",
          element: <UpdateItemPage />,
        },
        {
          path: "/orders",
          name: "resturant",
          element: <Order />,
        },
        {
          path: "/order-status",
          name: "resturant",
          element: <OrderStatusPos />,
        },
        {
          path: "/sales",
          name: "resturant",
          element: <Sales />,
        },
        {
          path: "/setting",
          name: "resturant",
          element: <Setting />,
        },
        {
          path: "/plans",
          name: "plans",
          element: (
            <PlansGuard>
              <Plans />
            </PlansGuard>
          ),
        },
        {
          path: "/customer/current-order",
          name: "customer",
          element: <Customer />,
        },
        {
          path: "*",
          name: "*",
          element: <NotFound />,
        },
      ],
    },
  ];
};
